export { default } from "./useAssignmentGet";
